module.exports = __webpack_public_path__ + "static/logo-square-6e2de9058cf032ae6a46c551d1b0bb99.png";